import { SystemStyleObject } from '@telescope/cassini-ui';

export const tabsStyle: SystemStyleObject = {
  '.slick-list': {
    overflow: 'visible',
  },

  '.slick-slider': {
    width: '100%',
  },

  '.slick-track': {
    display: 'flex',
  },

  '.slick-slide > div': {
    height: '100%',
    display: 'flex',
  },
};
